import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteIcon = _resolveComponent("SiteIcon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    flat: "",
    "no-caps": "",
    class: _normalizeClass([_ctx.isActive ? '' : 'text-grey-5', "site-category-chip"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_SiteIcon, {
        "social-site": _ctx.platform,
        color: _ctx.isActive ? '' : 'grey-5',
        size: "sm"
      }, null, 8, ["social-site", "color"])
    ]),
    _: 1
  }, 8, ["class"]))
}